(function (section_name) {
  // Q1 answer -> result screen / URL param (unique per result)
  var RESULTS = { a: 'fitness', b: 'everyday', c: 'outdoor', d: 'pain' };
  // Q5 answers that show a concern-note callout (D shows none)
  var NOTE_ANSWERS = { a: 1, b: 1, c: 1 };

  function resultKeyFromAnswers(root) {
    for (var k in RESULTS) {
      var el = root.querySelector('#bf04-q1-' + k);
      if (el && el.checked) return RESULTS[k];
    }
    return null;
  }
  function answerForResult(key) {
    for (var k in RESULTS) { if (RESULTS[k] === key) return k; }
    return null;
  }
  // letter (a/b/c) of the displayed Q5 callout, or null when none (D / unanswered)
  function noteFromAnswers(root) {
    for (var k in NOTE_ANSWERS) {
      var el = root.querySelector('#bf04-q5-' + k);
      if (el && el.checked) return k;
    }
    return null;
  }
  function urlWithState(key, note) {
    var url = new URL(window.location.href);
    if (key) { url.searchParams.set('result', key); } else { url.searchParams.delete('result'); }
    if (note) { url.searchParams.set('note', note); } else { url.searchParams.delete('note'); }
    return url.toString();
  }
  function showResult(root, key, note) {
    var ans = answerForResult(key);
    if (!ans) return false;
    var q1 = root.querySelector('#bf04-q1-' + ans);
    var step6 = root.querySelector('#bf04-step-6');
    if (q1) q1.checked = true;
    if (step6) step6.checked = true;
    if (note && NOTE_ANSWERS[note]) {
      var q5 = root.querySelector('#bf04-q5-' + note);
      if (q5) q5.checked = true;
    }
    return true;
  }
  function resetToEntry(root) {
    root.querySelectorAll('.answer').forEach(function (r) { r.checked = false; });
    var entry = root.querySelector('#bf04-step-0');
    if (entry) entry.checked = true;
  }

  function init() {
    var root = document.querySelector('.' + section_name + ' .bf04');
    if (!root) return;

    // Toggle native theme chrome visibility (CSS also hides it; this is a backup)
    if (root.getAttribute('data-hide-chrome') === 'true') {
      document.body.classList.add('acc-bf-lp-04-hide-chrome');
    }

    // When a result screen is reached, push a unique ?result= (+ ?note= for the
    // displayed Q5 callout) into history. This keeps the result AND its callout
    // visible on refresh / Back from a product page, and Back off the result
    // lands on the previous (param-less) entry which we reset below.
    var step6 = root.querySelector('#bf04-step-6');
    if (step6) {
      step6.addEventListener('change', function () {
        if (!step6.checked) return;
        var key = resultKeyFromAnswers(root);
        if (key) history.pushState({ bf04Result: key }, '', urlWithState(key, noteFromAnswers(root)));
      });
    }

    // Auto-advance on FIRST answer of each question this journey: selecting an answer
    // forwards to the next question. Returning to an already-answered question does NOT
    // auto-advance (user changes it and clicks Next). Reset on Start over.
    var seen = {};
    root.querySelectorAll('.answer').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var qn = parseInt((input.name || '').replace('bf04-q', ''), 10);
        if (!qn || seen[qn]) return;          // already visited -> require the Next button
        seen[qn] = true;                      // first answer for this question -> auto-advance
        var next = root.querySelector('#bf04-step-' + (qn === 5 ? 6 : qn + 1));
        if (!next) return;
        setTimeout(function () {
          next.checked = true;
          next.dispatchEvent(new Event('change', { bubbles: true }));
        }, 220);
      });
    });

    // Deep-link / refresh / Back-from-product restore: if the URL carries a result
    // param on load (document reloaded rather than served from bfcache), show it
    // along with its callout from ?note=.
    var params = new URLSearchParams(window.location.search);
    var initialKey = params.get('result');
    if (initialKey) showResult(root, initialKey, params.get('note'));

    // Browser Back/Forward (same document):
    //  - landed on a ?result= entry  -> show that result (+ its note callout)
    //  - landed on an entry without it (Back off the result) -> reset to entry screen
    window.addEventListener('popstate', function () {
      var p = new URLSearchParams(window.location.search);
      var key = p.get('result');
      if (key) { showResult(root, key, p.get('note')); }
      else { resetToEntry(root); }
    });

    // "Start over": reset every input and drop the result/note params from the URL.
    root.querySelectorAll('[data-bf04-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        resetToEntry(root);
        seen = {};
        history.replaceState({}, '', urlWithState(null, null));
        var top = root.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
      });
    });

    // Keep the section in view whenever the active step changes.
    root.querySelectorAll('.bf04__nav').forEach(function (nav) {
      nav.addEventListener('change', function () {
        var rect = root.getBoundingClientRect();
        if (rect.top < 0 || rect.top > 80) {
          window.scrollTo({ top: rect.top + window.pageYOffset, behavior: 'smooth' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})("acc_bf_lp_04_01");
